module.exports = __webpack_public_path__ + "static/media/DOUBLE_WELTED.ac36bb80.svg";